import {
	createRelativeDateRefs,
	formatClockTime,
	formatFullDate,
	formatMonthYear,
	formatDate as formatSharedDate,
	formatDateTime as formatSharedDateTime,
	formatDateTimeRange as formatSharedDateTimeRange,
	formatDisplayDate as formatSharedDisplayDate,
	formatRelativeTimestamp as formatSharedRelativeTimestamp,
	formatTime as formatSharedTime,
	getRelativeDateLabel as getSharedRelativeDateLabel,
	isOngoing,
	type RelativeDateRefs,
} from "@upsquad/shared";
import i18n from "i18next";

function currentLanguage(): string {
	return i18n.language;
}

export type { RelativeDateRefs };
export { createRelativeDateRefs, isOngoing };

export function formatTime(date: Date | string): string {
	return formatSharedTime(date, currentLanguage());
}

export function formatDate(date: Date | string): string {
	return formatSharedDate(date, currentLanguage());
}

export function formatLongDate(date: Date | string): string {
	return formatMonthYear(date, currentLanguage());
}

export function formatDateTime(date: Date | string): string {
	return formatFullDate(date, currentLanguage());
}

export function formatShortDateTime(date: Date | string): string {
	return formatSharedDateTime(date, currentLanguage());
}

export function getRelativeDateLabel(date: Date | string, t: (key: string) => string, refs?: RelativeDateRefs): string {
	return getSharedRelativeDateLabel(date, t, currentLanguage(), refs ?? createRelativeDateRefs());
}

export function formatTime12h(time24: string): string {
	return formatClockTime(time24, currentLanguage());
}

export function formatDateTimeRange(startAt: string, endAt: string): string {
	return formatSharedDateTimeRange(startAt, endAt, currentLanguage());
}

export function formatDisplayDate(date: Date | string): string {
	return formatSharedDisplayDate(date, currentLanguage());
}

export function formatRelativeTimestamp(date: Date | string): string {
	return formatSharedRelativeTimestamp(date, currentLanguage());
}
